import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function LeadAdultCareWorkerLevel3() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    LEAD ADULT CARE WORKER
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    APPRENTICESHIP LEVEL 3
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Overview of the role */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Overview of the role:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Leading frontline care for vulnerable adults within their own homes, day care centres, residential and nursing homes and other healthcare settings.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Details of standard */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Details of standard:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Lead Adult Care Workers are the frontline staff who help adults with care and support needs to achieve their personal goals and live as independently and safely as possible, enabling them to have control and choice in their lives. In addition, Lead Adult Care Workers have responsibility for providing supervision, frontline leadership, guidance and direction for others, or working autonomously, exercising judgement and accountability.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Typical job titles include Care Officer, Care Supervisor, Senior Care Worker, Supervising Care Worker, Senior Support Worker, Relief Team Leader, Social Work Assistant, Social Services Officer, Outreach Development Worker, Community Support Worker, Community Outreach Worker, Community Development Worker, Family Support Worker or Personal Assistant. These could all specialise in a variety of areas such as learning disability, mental health, drug and alcohol misuse, homecare, dementia and end-of-life care.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    As a Lead Adult Care Worker, you will make a positive difference to someone's life when they are faced with physical, practical, social, emotional or intellectual challenges. You will be expected to exercise judgement and take appropriate action to support individuals to maintain their independence, dignity and control. By providing leadership, guidance and direction at the frontline of care delivery you will be instrumental in improving the health and wellbeing of those receiving care and support. Lead Adult Care Workers will in some circumstances have delegated responsibility for the standard of care provided and may supervise the work of other care workers. This exercising of autonomy and accountability means leading and supporting others to comply with expected standards and behaviours.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Lead Adult Care Workers may work in residential or nursing homes, domiciliary care, day centres or some clinical healthcare settings. As well as covering Lead Adult Care Workers this standard also covers Lead Personal Assistants who can work at this senior level, but they may only work directly for one individual who needs support and/or care services, usually within their own home.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Personal attributes and behaviours */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    These are the personal attributes and behaviours expected of all lead adult care workers carrying out their roles:
                  </h3>
                  
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Care</strong> – is caring consistently and enough about individuals to make a positive difference to their lives
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Compassion</strong> – is delivering care and support with kindness, consideration, dignity, empathy and respect
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Courage</strong> – is doing the right thing for people and speaking up if the individual they support is at risk
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Communication</strong> – good communication is central to successful caring relationships and effective team working
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Competence</strong> – is applying knowledge and skills to provide high quality care and support
                    </li>
                    <li style={{ marginBottom: '0' }}>
                      <strong>Commitment</strong> – to improving the experience of people who need care and support ensuring it is person centred
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Duration */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Duration:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Typically, 18 months
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Level */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Level:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    3
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Qualifications */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Qualifications:
                  </h3>
                  
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '25px' }}>
                    <li>Level 3 Diploma in Adult Care.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Awarding Organisations: <strong>NCFE, TQUK.</strong>
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Individuals without level 2 English and maths will need to achieve this level prior to taking the end-point assessment. For those with an education, health and care plan or a legacy statement the apprenticeships English and maths minimum requirement is Entry Level 3 and British Sign Language qualification are an alternative to English qualifications for whom this is their primary language.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Industry-specific requirements */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Industry-specific requirements:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Undertake the Enhanced Disclosure and Barring Service process and provide the result prior to starting.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The individual must meet the 15 standards as set out in the Care Certificate. The Care Quality Commission expect that providers that employ healthcare assistants and social care support workers follow these standards to make sure new staff are supported, skilled and assessed as competent to carry out their roles.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default LeadAdultCareWorkerLevel3;